<template>
  <div class="summary-contract-holder">
      <h3><slot name="headline"></slot></h3>
    <ul class="list-unstyled">
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblFirstName"></slot>
          </div>
          <div>{{ mnpContractHolder.firstName }}</div>
        </div>
      </li>
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblLastName"></slot>
          </div>
          <div>{{ mnpContractHolder.lastName }}</div>
        </div>
      </li>
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblBirthdate"></slot>
          </div>
          <div>{{ mnpContractHolder.birthDate }}</div>
        </div>
      </li>
    </ul>
    </div>
</template>
<script>

export default {
  name: 'SummaryContractHolder',
  props: {
    mnpContractHolder: {
      type: Object,
      required: true
    }
  }
}
</script>
